export default __webpack_public_path__ + "static/media/masthead.5d5caa35.svg";